import * as React from "react";
import ReactSVG from "react-svg";
import "./scss/index.scss";

interface Medium {
  ariaLabel: string;
  path: string;
  href: string;
}

export interface IconProps extends React.HTMLProps<HTMLAnchorElement> {
  medium: Medium;
  target?: string;
}

const SocialMediaIcon: React.FC<IconProps> = ({ medium, target }) => (
  <a
    aria-label={medium.ariaLabel}
    href={medium.href}
    rel="noopener noreferrer"
    target={target || "_blank"}
  >
    <ReactSVG path={medium.path} className="social-icon" />
  </a>
);

export default SocialMediaIcon;
